import React from 'react';
import PropTypes from 'prop-types';
import PlaybuzzEmbed, {playbuzzPropsFromWidget} from "../../../Common/components/PlaybuzzEmbed";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const PlaybuzzEmbedWidget = ({bodyVisible, widget}) => {
  return bodyVisible && <div className="news-article-playbuzz">
    <PlaybuzzEmbed {...playbuzzPropsFromWidget(widget)}/>
  </div>;
};

PlaybuzzEmbedWidget.mapProps = (props) => ({
  bodyVisible: props.bodyVisible,
  widget: props.widget
})
PlaybuzzEmbedWidget.propTypes = {
  bodyVisible: PropTypes.bool,
  widget: PropTypes.object
}

export default withErrorBoundary(PlaybuzzEmbedWidget);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/PlaybuzzEmbed.widget.js